import { API } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

import HolidayForm from "components/holidays/HolidayForm";
import { createHoliday } from "graphql/mutations";

const HolidayCreateForm = ({ onSuccess }) => {
  const navigate = useNavigate();
  const holiday = {
    date: "",
    name: "",
  };

  async function onSubmit(valuesParam) {
    try {
      const { name, date } = valuesParam;

      await API.graphql({
        query: createHoliday.replaceAll("__typename", ""),
        variables: {
          input: {
            date,
            name,
          },
        },
      });

      toast.success(strings.successAdded);
      if (onSuccess) onSuccess();
      else navigate("/holidays");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  return (
    <div>
      <HolidayForm onSubmit={onSubmit} initialValues={holiday} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Agregar Día festivo",
    successAdded: "Día festivo agregado con éxito",
    responses: {},
  },
});

export default HolidayCreateForm;
